import { createContext } from 'react';
const NegociosContext = createContext(); 

export default NegociosContext;